import { all, call, put } from 'redux-saga/effects';

import React from 'react';
import { basketOperations } from '../../../store/basket';
import { createError } from '../../../store/errors';
import { getBasket } from '../../../api/basket';
import { messageOperations } from '../../../store/messages';

const { getBasketSuccess } = basketOperations;
const { sendMessage } = messageOperations;

/* eslint-disable max-lines-per-function, max-statements */

/**
 * This is a re-usable sub-saga used by other main action sagas
 *
 * @param {String} bookingRef booking reference
 * @param {Object} updateState do we push the basket to redux state?
 * @returns {Object} basket response
 */
const reloadBasket = function* reloadBasket(bookingRef, updateState = true) {
  const basketResponse = yield call(getBasket, bookingRef);

  if (basketResponse.errors) {
    // Handle web service errors.
    yield all(basketResponse.errors.map(error => put(createError(error))));
  }

  const { mandatory_status = {} } = basketResponse.basket ?? {};
  const { tickets, accommodation, extras, transport } = mandatory_status ?? {};
  const errorMessages = [];

  if (!tickets.valid && (tickets?.errors ?? []).length > 0) {
    tickets.errors.forEach(error => {
      errorMessages.push(error);
    });
  }

  if (!accommodation.valid && (accommodation?.errors ?? []).length > 0) {
    accommodation.errors.forEach(error => {
      errorMessages.push(error);
    });
  }

  if (!extras.valid && (extras?.errors ?? []).length > 0) {
    extras.errors.forEach(error => {
      errorMessages.push(error);
    });
  }

  if (!transport.valid && (transport?.errors ?? []).length > 0) {
    transport.errors.forEach(error => {
      errorMessages.push(error);
    });
  }

  if (updateState) {
    yield put(
      getBasketSuccess(basketResponse.bookingRef, basketResponse.basket),
    );
  }

  if (errorMessages.length > 0) {
    const messageNode = (
      <ul>
        {errorMessages.map((error, index) => (
          /* eslint-disable-next-line react/no-array-index-key */
          <li key={index}>{error}</li>
        ))}
      </ul>
    );

    yield put(
      sendMessage({
        displayType: 'prompt',
        type: 'warning',
        header: 'Warning',
        message: messageNode,
        actions: [
          {
            type: 'success',
            text: 'OK',
          },
        ],
        actioned: false,
        required: false,
      }),
    );
  }

  return basketResponse;
};

export default reloadBasket;
